import React from 'react'
import styled from 'styled-components'
import { useCurrentDragType } from './DragDropContext'

export type DroppableWrapProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  type: string
  enabled?: boolean
  insetLeft?: number
  insetRight?: number
}

export const DroppableHighlight = styled.div<{ highlight?: boolean; insetLeft?: number; insetRight?: number }>`
  position: relative;
  margin: -10px;
  padding: 10px;
  z-index: ${({ highlight }) => (highlight ? 10 : 9)};

  &::before {
    pointer-events: none;
    content: '';
    position: absolute;
    top: 0;
    left: ${({ insetLeft }) => insetLeft ?? 0}px;
    right: ${({ insetRight }) => insetRight ?? 0}px;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.3);
    border: 1px dashed #ffffff;
    opacity: ${({ highlight }) => (highlight ? 1 : 0)};
    transition: opacity 0.3s;
  }
`

const DroppableWrap = React.forwardRef<HTMLDivElement, DroppableWrapProps>(function DroppableWrap(
  { type, enabled = true, ...props },
  ref
) {
  const showHighlight = useCurrentDragType() === type
  return <DroppableHighlight {...props} ref={ref} highlight={enabled && showHighlight} />
})

export default DroppableWrap
